import { InfoText, StatusSectionRoot } from "../../shared/practitionerForm.styles";
import {
  STATUS_LABEL,
  STATUS_APPROVED,
  STATUS_PENDING,
} from "../ResourcesModal.constants";

const DirectoryStatusSection = ({ directoryStatus }) => {
  return (
    <StatusSectionRoot>
      <InfoText>
        *
        {directoryStatus ? (
          <span>
            {STATUS_LABEL}{" "}
            <span style={{ color: "green" }}>{STATUS_APPROVED}</span>
          </span>
        ) : (
          <span>
            {STATUS_LABEL}{" "}
            <span style={{ color: "red" }}>{STATUS_PENDING}</span>
          </span>
        )}
      </InfoText>
    </StatusSectionRoot>
  );
};

export default DirectoryStatusSection;
